<template>
	<div class="search__container">
		<a href="/" class="search__close"></a>
		<h2 class="search__title">
			{{ title }}
		</h2>
		<div class="search__wrapper">
			<form class="search__form">
				<div class="search__filedgroup">
					<div class="search__field-wrap">
						<button
							v-if="currentType"
							class="search__chosen-type"
							type="button"
							@click.prevent="defaultType"
							ref="currentTypeBtn"
						>
							{{ currentType === 'bank' ? 'Ипотека' : tags[currentType].text }}
						</button>
						<input
							class="search__field"
							type="text"
							:name="searchName"
							id="search-field"
							placeholder="Введите поисковый запрос"
							ref="searchField"
							v-model="searchValue"
							@input="searchHandler"
							autocomplete="off"
							@keydown.enter="onSubmit"
							:style="{ paddingLeft: searchPadding }"
						/>
						<button
							v-if="clearButton"
							class="search__clear"
							type="button"
							@click.prevent="clearSearchField"
						></button>
					</div>
					<button
						class="search__submit"
						@click.prevent="onSubmit"
						@keydown.enter="onSubmit"
					>
						{{ submitButton }}
					</button>
				</div>
				<div class="search__filedgroup">
					<ul class="search__tags">
						<template v-for="(tag, name, i) in tags" :key="name">
							<li v-if="tag.show === true" class="search__tag">
								<input
									class="visually-hidden"
									type="radio"
									name="tag"
									:value="name"
									:id="'search-' + name"
									v-model="currentType"
								/>
								<label
									class="search__label"
									:for="'search-' + name"
									@click="setSearchPadding(tag.metric)"
								>
									{{ name === 'bank' ? 'Ипотека' : tag.text }}
								</label>
								<button
									v-if="currentType && currentType === name"
									class="search__hiden-trigger"
									type="button"
									@click.prevent="defaultType"
								></button>
							</li>
						</template>
					</ul>
				</div>
			</form>
			<section class="search__result">
				<loader v-if="searchIsLoading" />
				<div v-if="!search || defaultList" class="search__default">
					<h3 class="search__subtitle">
						{{ popularTitle }}
					</h3>
					<div class="search__component">
						<ul class="search__popular-list">
							<li
								v-for="(item, i) in topCategories"
								:key="i"
								class="search__popular-item"
							>
								<a
									class="search__popular-link"
									:href="item.url"
									:title="item.title"
								>
									{{ item.title }}
								</a>
							</li>
						</ul>
					</div>
					<h3 class="search__subtitle">
						{{ companyDirections }}
					</h3>
					<ul class="search__directions-list">
						<li
							v-for="(item, i) in directins"
							:key="i"
							class="search__direction-item"
						>
							<a
								class="search__direction-link"
								:href="item.href"
								:title="item.title"
								target="_blank"
							>
								<div class="search__direction-img">
									<img
										:src="item.img"
										:alt="item.title"
										:title="item.title"
										width="48"
										height="48"
									/>
								</div>
								<div class="search__direction-wrap">
									<h4 class="search__direction-title">
										{{ item.title }}
									</h4>
									<p class="search__direction-desc">
										{{ item.desc }}
									</p>
								</div>
							</a>
						</li>
					</ul>
				</div>

				<div
					v-if="
						search &&
						Object.values(search.data).reduce((accumulator, currentEl) => [
							...accumulator,
							...currentEl,
						]).length !== 0
					"
					class="s-response"
				>
					<article
						v-for="(type, name, i) in search.data"
						class="s-response__type"
					>
						<ul v-if="type.length !== 0" class="s-response__list">
							<li
								v-for="(item, i) in type.slice(reponseArrStart, responseArrEnd)"
								:key="i"
								:data-type="item.category"
								class="s-response__item"
							>
								<div class="s-response__sub">
									{{ tags[item.category].text }}
								</div>
								<a
									class="s-response__link"
									:class="{ disabled: !item.url }"
									:href="item.url"
									:title="item.title"
									target="_blank"
									@click="
										sendMetrics(dinamicMetricsLinks[item.category], item.title)
									"
								>
									<h4 class="s-response__title">
										{{ item.subtitle ? '' : item.title }}
									</h4>
									<p
										v-if="item.category !== 'vacancies'"
										class="s-response__desc"
										v-html="item.subtitle ? item.subtitle : item.description"
									></p>
								</a>
								<div v-if="item.props" class="s-response__wrapper">
									<a
										v-if="item.props.file"
										class="s-response__file-link"
										:href="item.props.file.src"
										:title="item.props.file.name"
										:download="item.props.file.name"
										@click="
											sendMetrics(
												dinamicMetricsLinks[item.category],
												item.title
											)
										"
									>
										<div class="s-response__file">
											<svg
												width="10"
												height="19"
												viewBox="0 0 10 19"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M5.5 0L5.5 9H10L5 15L0 9H4.5L4.5 0H5.5ZM10 18.5V17.5H0V18.5H10Z"
													fill="#8BC540"
												/>
											</svg>
											<span v-if="item.category === 'msfo'">
												{{ item.title }}
											</span>
											<span v-else> Скачать отчёт </span>
										</div>
									</a>
									<div
										v-if="
											item.props.city ||
											item.props.company ||
											item.props.department
										"
										class="s-response__date"
									>
										{{ item.props.city + ',' }}
										{{ item.props.company + ',' }}
										{{ item.props.department }}
									</div>
									<div
										v-if="item.props.implementation_type"
										class="s-response__date"
										v-html="item.props.implementation_type.name"
									></div>
								</div>
								<div
									v-if="
										(item.date && item.category === 'analytics') ||
										item.category === 'news'
									"
									class="s-response__date"
									v-html="item.date"
								></div>
							</li>
						</ul>
					</article>
					<button
						v-if="
							Object.values(search.data).reduce((accumulator, currentEl) => [
								...accumulator,
								...currentEl,
							]).length > 10
						"
						type="button"
						class="s-response__show-more"
						@click.prevent="getMore"
					>
						<svg
							width="16"
							height="20"
							viewBox="0 0 16 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M13.8618 5.16489L8.69922 6.15122L10.5315 3.45351C9.74664 3.14896 8.89311 2.9819 8 2.9819C4.13401 2.9819 1 6.11591 1 9.9819C1 10.9849 1.21064 11.9374 1.58963 12.7986L0.674342 13.2014C0.240559 12.2157 0 11.1262 0 9.9819C0 5.56363 3.58172 1.9819 8 1.9819C9.1011 1.9819 10.1508 2.2046 11.1061 2.60742L12.8755 0.00231934L13.8618 5.16489ZM15 9.9819C15 8.99196 14.7948 8.05124 14.4251 7.19895L15.3425 6.801C15.7657 7.77654 16 8.85251 16 9.9819C16 14.4002 12.4183 17.9819 8 17.9819C6.78562 17.9819 5.63369 17.711 4.60208 17.2264L2.82805 19.8499L1.83116 14.6894L6.9917 13.6925L5.17006 16.3864C6.03511 16.7693 6.99236 16.9819 8 16.9819C11.866 16.9819 15 13.8479 15 9.9819Z"
								fill="black"
							/>
						</svg>
						<span>
							{{ showMore ? 'Скрыть' : 'Показать ещё' }}
						</span>
					</button>
				</div>

				<div
					v-if="
						search &&
						Object.values(search.data).reduce((accumulator, currentEl) => [
							...accumulator,
							...currentEl,
						]).length === 0
					"
					class="search__empty"
				>
					<h3 class="search__subtitle">
						{{ empty.title }}
					</h3>
					<p class="search__desc">
						{{ empty.desc }}
					</p>
					<div class="search__component">
						<ul class="search__popular-list">
							<li
								v-for="(item, i) in topCategories"
								:key="i"
								class="search__popular-item"
							>
								<a
									class="search__popular-link"
									:href="item.url"
									:title="item.title"
								>
									{{ item.title }}
								</a>
							</li>
						</ul>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import Loader from '../vue-components/Loader'
import LoadError from '../vue-components/LoadError'
import headerSearchTrigger from '../modules/header-search'
import { searchActionTypes } from '../store/modules/search/search'
import { mapState } from 'vuex'

export default {
	name: 'Search',
	components: {
		Loader,
		LoadError,
	},
	data() {
		return {
			apiUrlSearch: '/api/v2/search/',
			title: 'Поиск на сайте',
			popularTitle: 'Популярные разделы сайта',
			companyDirections: 'Все направления ДОМ.РФ',
			empty: {
				title: 'К сожалению, по вашему запросу ничего не найдено',
				desc: 'Возможно вам будет интересно:',
			},
			chosenType: false,
			defaultList: true,
			clearButton: false,
			currentType: null,
			searchPadding: '',
			searchValue: '',
			searchName: 'q',
			submitButton: 'Искать на сайте',
			urlParams: '',
			wait: false,
			reponseArrStart: 0,
			responseArrEnd: 10,
			showMore: false,
			tags: {
				bank: {
					text: 'Банк ДОМ.РФ',
					metric: 'search-tag-mortgage',
					show: true,
				},
				news: {
					text: 'Новости',
					metric: 'search-tag-news',
					show: true,
				},
				analytics: {
					text: 'Аналитика',
					metric: 'search-tag-analitics',
					show: true,
				},
				land: {
					text: 'Земля и недвижимость',
					metric: 'search-tag-land',
					show: true,
				},
				msfo: {
					text: 'Финансовая отчетность',
					metric: 'search-tag-finotch',
					show: false,
				},
				vacancies: {
					text: 'Вакансии',
					metric: 'search-tag-vacancy',
					show: true,
				},
			},
			dinamicMetricsLinks: {
				bank: 'search-link-domrf',
				news: 'search-link-news',
				analytics: 'search-link-analitics',
				land: 'search-link-land',
				vacancies: 'search-link-vacancy',
			},
			directins: [
				{
					img: '/static/dist/v2/img/internal-list-icons/domrf.svg',
					title: 'ДОМ.РФ',
					desc: 'Финансовый институт развития в жилищной сфере',
					href: '/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/sprosi-domrf.png',
					title: 'Спроси ДОМ.РФ',
					desc: 'Центр информационной поддержки ДОМ.РФ',
					href: 'https://xn--h1alcedd.xn--d1aqf.xn--p1ai/?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_main_rf_page.link&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/search/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/bank-domrf.png',
					title: 'Банк ДОМ.РФ',
					desc: 'Универсальный ипотечно-строительный банк',
					href: 'https://domrfbank.ru/?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_main_rf_page.link&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/search/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/arenda-domrf.png',
					title: 'Аренда ДОМ.РФ',
					desc: 'Развитие рынка арендного жилья и инвестиций в недвижимость',
					href: 'https://xn--80aald4bq.xn--d1aqf.xn--p1ai/?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_main_rf_page.link&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/search/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/UISHC.png',
					title: 'Наш ДОМ.РФ',
					desc: 'Единая информационная система жилищного строительства',
					href: 'https://xn--80az8a.xn--d1aqf.xn--p1ai/?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_main_rf_page.link&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/search/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/SHLZ.png',
					title: 'ЩЛЗ',
					desc: 'Щербинский лифтостроительный завод',
					href: 'https://www.shlz.ru/?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_main_rf_page.link&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/search/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/SOPF.png',
					title: 'СОПФ агент',
					desc: 'Облигации на финансирование инфраструктуры',
					href: 'https://xn--n1aceo.xn--d1aqf.xn--p1ai/?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_main_rf_page.link&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/search/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/domrf-immovables.png',
					title: 'ДОМ.РФ Девелопмент',
					desc: 'Федеральный девелопер',
					href: 'https://domrfdevelopment.ru/?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_main_rf_page.link&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/search/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/land-domrf.png',
					title: 'ДОМ.РФ Земля и Недвижимость',
					desc: 'Продажа земли и объектов недвижимости',
					href: 'https://xn--e1adnd0h.xn--d1aqf.xn--p1ai/?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_main_rf_page.link&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/search/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/state-support-programs.png',
					title: 'Программы господдержки',
					desc: 'Для регионов, граждан и застройщиков',
					href: '/programmy-gosudarstvennoj-podderzhki/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/digital-academy.png',
					title: 'Цифровая академия',
					desc: 'Актуальные знания от ведущих экспертов строительной индустрии',
					href: 'https://xn--80az8a.xn--d1aqf.xn--p1ai/%D0%B0%D0%BA%D0%B0%D0%B4%D0%B5%D0%BC%D0%B8%D1%8F?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_main_rf_page.link&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/search/',
				},
				{
					img: '/static/dist/v2/img/internal-list-icons/mortgage-agent.png',
					title: 'Ипотечный агент',
					desc: 'Ипотечные облигации с поручительством ДОМ.РФ',
					href: 'https://xn--90an6b.xn--d1aqf.xn--p1ai/?utm_source=dom.rf&utm_medium=referral&utm_campaign=ref_601_main_rf_page.link&utm_content=%D0%B4%D0%BE%D0%BC.%D1%80%D1%84/search/',
				},
			],
			topCategories: [
				{
					title: 'Программы господдержки',
					url: '/programmy-gosudarstvennoj-podderzhki/',
				},
				{
					title: 'Залоговая недвижимость',
					url: '/property/',
				},
				{
					title: 'Аналитика',
					url: '/analytics/',
				},
				{
					title: 'Начало карьеры',
					url: '/career/start/',
				},
				{
					title: 'Единая отчетность по льготному ипотечному кредитованию',
					url: '/programmy-gosudarstvennoj-podderzhki/report/',
				},
				{
					title: 'О компании',
					url: '/about/',
				},
				{
					title: 'Городская среда',
					url: '/urban/',
				},
				{
					title: 'Контакты',
					url: '/contacts/',
				},
			],
		}
	},
	methods: {
		sendMetrics(metric, linkText = null) {
			let params = {
				URL: document.location.href,
			}

			if (linkText) {
				params.SEARCH_LINK_TEXT = linkText
			}

			ym(50230510, 'reachGoal', metric, params)
		},

		clearSearchField() {
			this.searchValue = ''
			this.$refs.searchField.focus()
			this.clearButton = false
			this.defaultType()
		},

		onSubmit() {
			if (!this.currentType && !this.searchValue) return
			if (!this.currentType && this.searchValue) {
				this.urlParams = `?${this.searchName}=${this.searchValue}`
			} else {
				this.urlParams = `?type=${this.currentType}&${this.searchName}=${this.searchValue}`
			}

			if (!this.chosenType) {
				this.urlParams += '&union=1'
			}

			this.$store.dispatch(searchActionTypes.getSearch, {
				apiUrl: this.apiUrlSearch,
				searchValue: this.urlParams,
			})
			history.pushState(
				null,
				null,
				`${window.location.href.split('?')[0]}${this.urlParams}`
			)
			this.defaultList = false
			this.responseArrEnd = 10

			this.sendMetrics('search-enter-request')
		},

		defaultType() {
			this.searchPadding = '20px'
			this.currentType = null
			this.chosenType = false

			if (this.searchValue.length === 0) {
				this.defaultList = true
				this.$store.dispatch(searchActionTypes.setDefault)
				history.pushState(null, null, window.location.href.split('?')[0])
			} else {
				this.urlParams = `?${this.searchName}=${this.searchValue}&union=1`
				this.$store.dispatch(searchActionTypes.getSearch, {
					apiUrl: this.apiUrlSearch,
					searchValue: this.urlParams,
				})
				history.pushState(
					null,
					null,
					`${window.location.href.split('?')[0]}${this.urlParams}`
				)
			}
		},

		setSearchPadding(metricType) {
			this.sendMetrics(metricType)
			this.chosenType = true
			setTimeout(() => {
				this.searchPadding = `${this.$refs.currentTypeBtn.offsetWidth + 20}px`
				this.onSubmit()
			}, 100)
		},

		showClearBtn() {
			this.searchValue.length !== 0
				? (this.clearButton = true)
				: (this.clearButton = false)
		},

		searchHandler() {
			this.showClearBtn()

			if (this.searchValue.length > 2) {
				const DELAY = 500
				if (!this.wait) {
					this.wait = true
					setTimeout(() => {
						this.wait = false
						this.onSubmit()
					}, DELAY)
				}
			} else {
				this.defaultList = true
				history.pushState(null, null, window.location.href.split('?')[0])
				this.$store.dispatch(searchActionTypes.setDefault)
			}
		},

		getMore() {
			const ITEMS_PAGE = 10
			const countAllArticles = Object.values(this.search.data).reduce(
				(accumulator, currentEl) => [...accumulator, ...currentEl]
			).length
			if (this.responseArrEnd < countAllArticles) {
				this.responseArrEnd += ITEMS_PAGE
				if (this.responseArrEnd >= countAllArticles) {
					this.showMore = true
				}
			} else {
				this.responseArrEnd = ITEMS_PAGE
				this.showMore = false
			}
		},
	},
	computed: {
		...mapState({
			searchIsLoading: state => state.search.isLoading,
			search: state => state.search.data,
			searchError: state => state.search.error,
		}),
	},
	mounted() {
		let filterParams = ''
		if (
			window.location.href.indexOf('search') !== -1 &&
			window.location.href.indexOf('/analytics/search-results/') === -1 &&
			window.location.search
		) {
			filterParams = window.location.search

			if (window.location.search.indexOf('q=') !== -1) {
				this.searchValue = decodeURI(
					window.location.search.split('q=')[1].split('&')[0]
				)
			}

			if (window.location.search.indexOf('type=') !== -1) {
				this.currentType = window.location.search
					.split('type=')[1]
					.split('&')[0]
				this.setSearchPadding()
			}

			this.$store.dispatch(searchActionTypes.getSearch, {
				apiUrl: this.apiUrlSearch,
				searchValue: filterParams,
			})
			this.defaultList = false
		}

		this.showClearBtn()
		headerSearchTrigger()
	},
}
</script>
